module.exports = __webpack_public_path__ + "img/01a.199fa8fc.jpg";